import { ReadEmployee, UpdateEmployee } from "@/services/gql/graphql.generated"

/*
 * Super annoying hack!
 * 
 * When updating an employee, there are a bunch of optional fields. So the backend interprets any value
 * of undefined as meaning 'clear this data'.
 * 
 * The employee object is massive, so it's very easy to forget about part of the data that you need to send
 * back.
 * 
 * This allows you to take an existing employee, and create a base update object which won't break anything.
 */
export const readEmployeeToUpdateEmployee = (employee: ReadEmployee): UpdateEmployee => {
  return {
    email: employee.email,
    phoneNumber: employee.phoneNumber,
    firstName: employee.firstName || '',
    lastName: employee.lastName || '',
    identityId: employee.identityId,
    role: employee.role,
    contractTypeId: employee.contract?.contractTypeId,
    contractRoleId: employee.contractRoleId,
    contractModification: employee.contract?.contractModificationId,
    employeeId: employee.employeeId,
    isRosterable: employee.isRosterable,
    homeLocationId: employee.homeLocationId,
    locationIds: employee.locations?.map(l => l.id),
    dateOfBirth: employee.dateOfBirth,
    hireDate: employee.hireDate,
    leaveDate: employee.leaveDate,
    endOfProbationDate: employee.endOfProbationDate,
    personaIds: employee.personas?.map(p => p.id),
    properties: employee.properties,
    title: employee.title,
    userName: employee.userName,
    isDeactivated: employee.isDeactivated
  }
}